<!-- web/movie-order-create -->

<template>
  <div>正在创建电影订单...</div>
</template>

<script>
import { mall_wx_goods_get_movie_by_tradeno } from "@/api/goods-api";
import { GOODS_CATE_INFO, GOODS_TYPE_DU_MOVIE, MallModules } from "@/api/constant";
import { Dialog } from "vant";

export default {
  name: "movie-order-create",

  created() {
    budo_log.info('#14 movie-order-create created')

    const module = MallModules.find((mall) => mall.topCateId === 2);
    sessionStorage.setItem('rc.module-info', JSON.stringify(module))

    this.$store.commit("SET_MALL_MODULE", module)
    this.$store.commit("CLEAR_CART")

    const tradeno = this.$route.query.tradeno

    mall_wx_goods_get_movie_by_tradeno(tradeno).then((res) => {
      if (res.code !== 0) {
        Dialog({ message: res.msg || "失败, 去订单列表?" }).then(() => {
          this.$router.replace({ path: 'order-list', query: { orderType: 'movie' } })
        })
        return
      }

      const newOrderInfo = {
        goodsType: GOODS_TYPE_DU_MOVIE,
        userAddressId: 0,
        total: res.data.payamount * 100,
        cityCode: res.data.citycode,
        tradeno,
        goodsList: [
          {
            goods: {
              name: res.data.moviename,
              img: res.data.movielogo,
              price: res.data.payamount * 100,
              count: res.data.quantity,
              goodsId: 0,
              identityAuth: false,
              cinemaname: res.data.cinemaname,
              playtime: res.data.playtime,
              roomname: res.data.roomname,
              seats: res.data.seats
            },
            checked: true,
            count: res.data.quantity,
          },
        ],
        timeId: new Date().getTime(),
        cateCode: GOODS_CATE_INFO.movie.code,
      }

      budo_log.info("#61 before actions_createOrderInfo user-center-order-submit", newOrderInfo)

      // 这里会写入 store 信息
      this.$store.dispatch("actions_createOrderInfo", newOrderInfo).then(() => {
        this.$router.push({
          path: '/user-center-order-submit', query: {
            orderMode: '1',
            cateId: GOODS_CATE_INFO.movie.id.toString(),
            goodsType: GOODS_TYPE_DU_MOVIE
          }
        })
      })
    })
  }
};
</script>